import styled from 'styled-components';

export const Container = styled.div({
  position: 'relative',

  display: 'flex',
  alignItems: 'center',
});

export const Label = styled.label(({ theme }) => ({
  display: 'flex',

  cursor: 'pointer',

  paddingInlineStart: '10rem',

  flexGrow: 1,

  fontFamily: theme.typography.family.arial,
}));

const radioSize = '16rem';
const checkboxSize = '14rem';

export const Input = styled.input(({ theme }) => ({
  '-moz-appearance': 'initial', // see: https://stackoverflow.com/a/59591634

  position: 'relative',

  margin: 0,
  width: checkboxSize,
  height: checkboxSize,

  outline: 'none',

  '&::before, &::after': {
    content: '""',

    position: 'absolute',
    inset: 0,

    cursor: 'pointer',

    transition: 'background-color 300ms linear',
  },

  '&::before': {
    border: `1rem solid ${theme.filter.primary.text}`,
    backgroundColor: theme.filter.primary.bg,
  },

  '&:checked::after': {
    backgroundColor: theme.filter.primary.bgActive,
  },

  '&[data-style="radio"]': {
    appearance: 'none',
    width: radioSize,
    height: radioSize,

    '&::before, &::after': {
      borderRadius: '50%',
    },

    '&::before': {
      borderWidth: '1.6rem',
    },

    '&:checked::after': {
      margin: '4rem',
    },
  },

  '&:focus::before': {
    outline: `2rem solid ${theme.filter.primary.text}`,
    outlineOffset: '1rem',
  },

  [`&[disabled]::before, &[disabled] + ${Label}`]: {
    borderColor: theme.filter.primary.textDisabled,
    color: theme.filter.primary.textDisabled,
    pointerEvents: 'none',
  },

  '&[disabled]:checked::after': {
    backgroundColor: theme.filter.primary.bgDisabled,
  },
}));
